// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Unlock } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconUnlock(props: any) {
    return <IconBase icon={Unlock} {...props} />
  }

  export default IconUnlock
  